import {translation} from "@2d-front-monorepo/core";
import {Message} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";

export default function InvalidPermitId({permitId}: { permitId: string | undefined }): JSX.Element {
	return <Message title={{text: translation(PermitTranslations.error__invalid_permit_id, {value: permitId})}} type="error"/>;
}
